import * as Sentry from '@sentry/browser';
import React, { FC } from 'react';
import { GetSyncedAppointmentStatus as GetSyncedAppointmentStatusQuery } from '../../../../GraphQL';
import { Button, message } from 'antd';
import { useLazyQuery } from '@apollo/client';
import { ReferralData } from './GetReferralQuery';
import { AppointmentData } from './GetReferralQuery';

interface GetSyncedAppointmentStatusQueryVars {
  id: string;
}

interface GetSyncedAppointmentStatusQueryData {
  getSyncedAppointmentStatus: {
    id: string;
    status: string;
  };
}

export const GetSyncedAppointmentStatus: FC<{
  referral?: ReferralData;
  appointment?: AppointmentData;
  onComplete: (data?: any) => void;
}> = ({ referral, appointment, onComplete }): JSX.Element | null => {
  const [getSyncedAppointmentStatus, { error }] = useLazyQuery<
    GetSyncedAppointmentStatusQueryData,
    GetSyncedAppointmentStatusQueryVars
  >(GetSyncedAppointmentStatusQuery, {
    fetchPolicy: 'network-only',
    onCompleted: data => {
      onComplete(data);
    },
  });

  const syncAppointment = appointment || referral?.appointment;

  if (!syncAppointment) {
    return null;
  }

  if (error) {
    Sentry.captureException(error);
    message.error('Error syncing appointment status');
  }

  const handleClick = (): void => {
    getSyncedAppointmentStatus({
      variables: {
        id: syncAppointment.id,
      },
    });
  };

  return (
    <>
      <Button onClick={handleClick}> Sync Appointment Status</Button>
    </>
  );
};
